import { Button, Create, SaveButton, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import { IncludeAndEditCampaignForm } from "components/forms/frm_parameterize-triggers-templates";
import { FC } from "react";

export const ParameterizeTriggersTemplatesCreate: FC<
  IResourceComponentsProps
> = () => {
  const { goBack, push } = useNavigation();

  const { formProps, saveButtonProps, queryResult } = useForm({
    resource: "v1/repique-campaign",
    redirect: false,
    successNotification: {
      type: "success",
      message: "Sucesso",
      description: "Operação realizada com sucesso",
    },
    errorNotification: (error: any) => ({
      type: "error",
      message: error?.response?.data?.detail ?? "Erro ao criar campanha",
    }),
    onMutationSuccess: () => push("/engaging/parameterize-triggers-templates"),
  });

  return (
    <Create
      title="Incluir"
      footerButtons={() => (
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Button onClick={() => goBack()}>Cancelar</Button>

          <SaveButton {...saveButtonProps} icon={null}>
            Incluir
          </SaveButton>
        </div>
      )}
    >
      <IncludeAndEditCampaignForm
        formProps={{
          ...formProps,
          onFinish: (values: any) => {
            // Envia apenas o nome da campanha
            const payload = {
              name: values.name,
            };

            // Chama o onFinish do formProps para executar o POST
            formProps.onFinish?.(payload);
          },
        }}
        queryResult={queryResult}
      />
    </Create>
  );
};
